// crypto.randomUUID only exists in secure contexts; a LAN kiosk on plain
// http may not be one, so fall back to getRandomValues.
export function uid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto && globalThis.isSecureContext !== false) {
    try {
      return crypto.randomUUID();
    } catch {
      /* fall through */
    }
  }
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
